import { BuildConfig } from '../env.config';

/**
 * Message overrides driven by BuildConfig.FEATURES.
 *
 * Applied by ./index.js on top of locales/ + variants/ messages, so a school opts in with a
 * single flag in its variants/<customer>/build.config.js instead of repeating the strings in
 * its variant language file. See variants/readme.txt (BuildConfig > FEATURES).
 *
 * Keyed by react-intl locale. en-US only, on purpose: these are British-curriculum terms with
 * no agreed de/fr/ja equivalent, and overriding a real translation with English would be worse
 * than leaving it alone.
 */

// Schools on the British curriculum read "Grade"/"Class" as the wrong vocabulary. The pupil
// profile (StudentDetails / StudentForm) and the Absences list share these message ids, so both
// surfaces relabel together — the underlying fields are the same (details.ncYear, details.form).
const UK_CURRICULUM_LABELS = {
  'en-US': {
    'absences.filter.grade': 'NC Year',
    'absences.table.header.grade': 'NC Year',
    'absences.filter.class': 'Form',
    'absences.table.header.class': 'Form',
  },
};

const FEATURE_MESSAGES = [['ukCurriculumLabels', UK_CURRICULUM_LABELS]];

export default function featureMessages(locale) {
  const features = BuildConfig.FEATURES || {};

  return FEATURE_MESSAGES.reduce(
    (messages, [feature, overrides]) =>
      features[feature] ? { ...messages, ...(overrides[locale] || {}) } : messages,
    {},
  );
}
